import React from 'react';
import FundingCommissionStatusBadge from './FundingCommissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingCommissionClawbackPanel = ({ commissions, onSelect }) => {
  const monitored = (commissions || []).filter(
    (item) => ['Monitoring', 'At Risk', 'Triggered'].includes(item.clawbackStatus)
      || ['Low', 'Medium', 'High'].includes(item.clawbackRisk),
  );

  if (!monitored.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No commissions under clawback monitoring.</p>;
  }

  return (
    <div className="space-y-3">
      {monitored.map((commission) => (
        <button
          key={commission.id}
          type="button"
          onClick={() => onSelect?.(commission)}
          className="flex w-full items-center justify-between rounded-xl border border-orange-200 bg-orange-50 px-4 py-3 text-left dark:border-orange-900/40 dark:bg-orange-950/20"
        >
          <div>
            <div className="font-medium text-[var(--fg-text)]">{commission.clientName}</div>
            <div className="text-xs text-[var(--fg-muted)]">
              {commission.lenderName} · Risk {commission.clawbackRisk} · {commission.clawbackStatus}
            </div>
          </div>
          <div className="text-right">
            <FundingCommissionStatusBadge status={commission.status} />
            <div className="mt-1 text-xs font-medium text-orange-700 dark:text-orange-200">
              {formatCurrency(commission.commissionAmount)} at risk
            </div>
          </div>
        </button>
      ))}
    </div>
  );
};

export default FundingCommissionClawbackPanel;
